// extracted by mini-css-extract-plugin
export default {"skillCard":"skills_skillCard__QKlAO","swirl":"skills_swirl__fYKj5"};